import Header from "@/types/app/header";

export default class CommunicationEmailNotification {
  public static header: Header[] = [
    {
      text: "Send date",
      align: "start",
      sortable: true,
      value: "dtNotification",
      class: "item-table-header item-table-header-date",
      width: ""
    },    
    {
      text: "Title",
      align: "start",
      sortable: true,
      value: "title",
      class: "item-table-header item-table-header-amount",
      width: ""
    },
    {
      text: "Subject",
      align: "start",
      sortable: true,
      value: "description",
      class: "item-table-header item-table-header-subject",
      width: ""
    },   
    {
      text: "Page Request",
      align: "start",
      sortable: true,
      value: "url",
      class: "item-table-header item-table-header-url",
      width: ""
    },    
    {
      text: "Author",
      align: "start",      
      sortable: true,
      value: "authorName",
      class: "item-table-header item-table-header-authorName",
      width: ""
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
